export default function getDomain() {
  switch (window.location.host) {
    case 'localhost:8080':
      return 'https://localhost:44354/api'
    case 'localhost:8081':
      return 'https://localhost:44354/api'
    case 'admin.adplatform.gjirafa.dev':
      return 'https://client.gjirafa.dev/api'
    case 'admin-dev.ap.gjirafa.tech':
      return 'https://api-dev.ap.gjirafa.tech/api'
    case 'admin-stg-gjirafa.ap.gjirafa.tech':
      return 'https://api-stg-gjirafa.ap.gjirafa.tech/api'
    case 'admin-gjirafa.ap.gjirafa.tech':
      return 'https://api-gjirafa.ap.gjirafa.tech/api'
    case 'admin-brazil.ap.giraffa.tech':
      return 'https://api-brazil.ap.giraffa.tech/api'
    case 'gjirafa.adplatform.gjirafa.tech':
      return 'https://gjirafa-api.adplatform.gjirafa.tech/api'
    case 'gjirafa-stg.adplatform.gjirafa.tech':
      return 'https://gjirafastg-api.adplatform.gjirafa.tech/api'
    default:
      return 'https://client.gjirafa.dev/api'
  }
}
